import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  useToast,
  Image,
  Flex,
} from '@chakra-ui/react';
import React, { useState } from 'react';

export default function AddCategoryModal({ isOpen, onClose, onAdd }) {
  const [formData, setFormData] = useState({ name: '' });
  const toast = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.name.trim()) {
      toast({
        title: "Hata",
        description: "Kategori adı zorunludur",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
      return;
    }

    const capitalizedName = formData.name.trim().toLowerCase().replace(/^./, str => str.toUpperCase());

    const categoryData = {
      name: capitalizedName,
    };

    onAdd(categoryData);
    onClose();
    setFormData({ name: '' });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent>
        <ModalHeader color="#e45858">Kategori Ekle</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <form onSubmit={handleSubmit}>
            <FormControl mb={4} isRequired>
              <FormLabel>Kategori Adı</FormLabel>
              <Input
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />
            </FormControl>
            <ModalFooter>
              <Flex justify="flex-end" mt={4}>
                <Button colorScheme="red" bgColor="#e45858" onClick={handleSubmit}>
                  Ekle
                </Button>
              </Flex>
            </ModalFooter>
          </form>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}